// extracted by mini-css-extract-plugin
module.exports = {"trustedRetailerBanner":"ai","trustedRetailerTooltipWrapper":"bi"};